import './manager-info.scss';

import { useContext, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { DatePickerField, Input, Select } from '@/components/Shared/ui';
import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../LlpOrder';
import type { CreateLeasingProps } from '../../widgets/create-tab';

const ManagerInfo: React.FC = () => {
  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { dicts } = useAppSelector((state) => state.dict);

  const {
    control,
    formState: { errors }
  } = useFormContext<CreateLeasingProps>();

  const documents = useMemo(
    () =>
      setDictionaryOptions(DictTypes.DocumentTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: item.label
      })) || [],
    [dicts]
  );

  return (
    <div className="manager-info">
      <Controller
        control={control}
        name="managerName"
        rules={{
          required: 'Пожалуйста, введите данные',
          minLength: { value: 1, message: 'Пожалуйста, введите данные' }
        }}
        render={({ field }) => (
          <Input
            {...field}
            label="ФИО первого руководителя"
            error={errors.managerName?.message}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="managerDocument"
        rules={{
          required: 'Пожалуйста, выберите значение',
          minLength: { value: 1, message: 'Пожалуйста, введите данные' }
        }}
        render={({ field }) => (
          <Select
            {...field}
            label="Документ"
            selectedValue={documents.find((item) => item.value === field.value)}
            onChange={(value) => {
              field.onChange(value.value);
            }}
            options={documents}
            error={errors.managerDocument?.message}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="managerDocumentNumber"
        rules={{
          required: 'Пожалуйста, введите данные',
          minLength: { value: 1, message: 'Пожалуйста, введите данные' }
        }}
        render={({ field }) => (
          <Input
            {...field}
            type="tel"
            label="№ документа"
            onChange={(e) => {
              const value = e.target.value;
              if (value.match(/\D/)) return;
              field.onChange(e);
            }}
            error={errors.managerDocumentNumber?.message}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="managerDocumentIssueDate"
        rules={{
          required: 'Пожалуйста, введите данные',
          validate: (value) => {
            const shouldValidate = value.length === '01.01.2020'.length;
            if (!shouldValidate) return 'Неверный формат даты';
          }
        }}
        render={({ field }) => (
          <DatePickerField
            {...field}
            label="Дата выдачи"
            isRequired
            error={errors.managerDocumentIssueDate?.message?.toString() || ''}
            disableFuture
            viewFormat="DD.MM.YYYY"
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="managerDocumentEndDate"
        rules={{
          required: 'Пожалуйста, введите данные',
          validate: (value) => {
            const shouldValidate = value.length === '01.01.2020'.length;
            if (!shouldValidate) return 'Неверный формат даты';
          }
        }}
        render={({ field }) => (
          <DatePickerField
            {...field}
            label="Дата окончания"
            isRequired
            error={errors.managerDocumentEndDate?.message?.toString() || ''}
            disablePast
            viewFormat="DD.MM.YYYY"
            isFrozen={isFieldsFrozen}
          />
        )}
      />
    </div>
  );
};

export default ManagerInfo;
